import { render, staticRenderFns } from "./ActiveDraftButton.vue?vue&type=template&id=3f090280&scoped=true&"
import script from "./ActiveDraftButton.vue?vue&type=script&lang=js&"
export * from "./ActiveDraftButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f090280",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})


/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3f090280')) {
      api.createRecord('3f090280', component.options)
    } else {
      api.reload('3f090280', component.options)
    }
    module.hot.accept("./ActiveDraftButton.vue?vue&type=template&id=3f090280&scoped=true&", function () {
      api.rerender('3f090280', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Papers/pages/Paper/components/ActiveDraftButton.vue"
export default component.exports